export class GroupValidator {
  public static isAnnouncemnet(group: string): boolean {
    return group === 'announcement';
  }

  public static isJustBelowBanner(group: string): boolean {
    return group === 'just-below-banner';
  }

  public static isJustBelowTable(group: string): boolean {
    return group === 'just-below-table';
  }

  public static isJustAboveTable(group: string): boolean {
    return group === 'just-above-table';
  }

  public static isJustBelowVoucher(group: string): boolean {
    return group === 'just-below-voucher';
  }

  public static isAboveNoteSection(group: string): boolean {
    return group === 'just-above-note';
  }
  public static isBelowNoteSection(group: string): boolean {
    return group === 'just-below-note';
  }
  public static isCardNoteSection(group: string): boolean {
    return group === 'just-card-note';
  }

  public static isJustAboveIagImageReports(group: string): boolean {
    return group === 'Reports';
  }
  public static isJustBelowIagImageReports(group: string): boolean {
    return group === 'ReportsXML';
  }

  public static isUserManagement(group: string): boolean {
    return group === 'user-management';
  }

  public static isUserManagementAddingAdmin(group: string): boolean {
    return group === 'user-management-adding-admin';
  }
  public static isUserManagementAddingNewEmployees(group: string): boolean {
    return group === 'adding-new-employees';
  }
  public static isUserManagementPasswordResets(group: string): boolean {
    return group === 'user-management-pass-resets';
  }
  public static isUserManagementTwoFactor(group: string): boolean {
    return group === 'user-management-authentication';
  }

  public static isDisruptedBookingsIntro(group: string): boolean {
    return group === 'disrupted-bookings-introduction';
  }
  public static isDisruptedBookingsLimitations(group: string): boolean {
    return group === 'disrupted-bookings-limitations';
  }

  public static isDisruptedBookings(group: string): boolean {
    return group === 'disrupted-bookings';
  }
  public static isDisruptedBookingsChange(group: string): boolean {
    return group === 'disrupted-bookings-change';
  }
  public static isDisruptedBookingsCancel(group: string): boolean {
    return group === 'disrupted-bookings-cancel-refund';
  }
  public static isDisruptedBookingsRebook(group: string): boolean {
    return group === 'disrupted-bookings-rebook';
  }
  public static isDisruptedBookingsRebooking(group: string): boolean {
    return group === 'disrupted-bookings-rebooking-flights';
  }
  public static isPleaseBeAwareNote(group: string): boolean {
    return group === 'please-be-aware-note';
  }
  public static isDisruptedBookingsNote(group: string): boolean {
    return group === 'disrupted-bookings-note';
  }
  public static isRemoveFromQueueNote(group: string): boolean {
    return group === 'remove-from-queue-note';
  }

  public static isDisruptedBookingsRemove(group: string): boolean {
    return group === 'remove-from-queue';
  }
  public static isDisruptedBookingsNotReceiving(group: string): boolean {
    return group === 'not-receiving-disruption-notifications';
  }
  public static isDisruptedBookingsPleaseBeAware(group: string): boolean {
    return group === 'please-be-aware-note';
  }
  public static isTopSection(group: string): boolean {
    return group === 'NDC Commercial FAQ#Payments#TopSection';
  }
  public static isTopTableSection(group: string): boolean {
    return group === 'NDC Commercial FAQ#Payments#TopTableSection';
  }
  public static isMiddleSection(group: string): boolean {
    return group === 'NDC Commercial FAQ#Payments#MiddleSection';
  }
  public static isMiddleTableSection(group: string): boolean {
    return group === 'NDC Commercial FAQ#Payments#MiddleTableSection';
  }
  public static isBottomSection(group: string): boolean {
    return group === 'NDC Commercial FAQ#Payments#BottomSection';
  }
  public static isAPIAvailabilityDanger(group: string): boolean {
    return group === 'api-availability-danger';
  }
  public static isImportantToKnow(group: string): boolean {
    return group === 'important-to- know';
  }
  public static isWarning(group: string): boolean {
    return group === 'warning';
  }
  public static isAboveNoteWarning(group: string): boolean {
    return group === 'above-note-warning';
  }
  public static isBelowNoteWarning(group: string): boolean {
    return group === 'below-note-warning';
  }
}
